import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { analytics } from './GoogleTagManager';

export default function GA4TrackingComponent() {
    const location = useLocation();
    const user = useSelector((state) => state.user);

    useEffect(() => {
        const pageName = location.pathname.split('/').pop() || 'landing';
        const intakeType = user.returning ? 'return' : 'new';
        const title = `pxn_${intakeType}_intake_${pageName}`;

        document.title = title;

        ReactGA.send({
            hitType: "page_view",
            page: location.pathname,
            title: title
        });

        analytics.track('page_view', {
            page: location.pathname,
            title: title
        });

    }, [location, user.returning]);

    return null;
}